module.exports = __webpack_public_path__ + "img/m5-1.5ec1ad8f.png";